module.exports = __webpack_public_path__ + "img/X3.a00ce6fa.png";